<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			id="exportTab"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			height="700px"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
		>
			<el-table-column label="排名" width="80px">
				<template slot-scope="scope">
					<span
						class="home_article_0"
						:class="
							scope.row.index == 1
								? 'home_article_1'
								: scope.row.index == 2
								? 'home_article_2'
								: scope.row.index == 3
								? 'home_article_3'
								: 'home_article_0'
						"
						>{{ scope.row.index }}</span
					>
				</template>
			</el-table-column>
			<el-table-column prop="id" label="id" width="80px"> </el-table-column>
			<el-table-column prop="title" label="资讯标题" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="文章类型" width="80px">
				<template slot-scope="scope">
					<span v-if="scope.row.type == 1">文章</span>
					<span v-if="scope.row.type == 2">快讯</span>
					<span v-if="scope.row.type == 5">专栏</span>
					<span v-if="scope.row.type == 7">活动</span>
				</template>
			</el-table-column>
			<el-table-column prop="option_type" label="操作类型">
				<template slot-scope="scope">
					<span v-if="scope.row.option_type == 1">人工原创</span>
					<span v-if="scope.row.option_type == 2">AI原创</span>
					<span v-if="scope.row.option_type == 3">AI转载</span>
					<span v-if="scope.row.option_type == 4">人工转载</span>
					<span v-if="scope.row.option_type == 5">PR</span>
				</template>
			</el-table-column>
			<el-table-column prop="nickname" label="作者" width="160px">
			</el-table-column>
			<el-table-column prop="adminName" label="编辑" width="140px">
			</el-table-column>
			<el-table-column prop="pv" label="阅读量" width="100px">
			</el-table-column>
			<el-table-column prop="pc_pv" label="PC网页" width="100px">
			</el-table-column>
			<el-table-column prop="h5_pv" label="H5网页" width="100px">
			</el-table-column>
			<el-table-column prop="app_pv" label="APP" width="100px">
			</el-table-column>
			<el-table-column prop="release_time" label="发布时间" width="200px">
			</el-table-column>
			<el-table-column label="预览" width="120px">
				<template slot-scope="scope">
					<span class="pointer margin_left_10" @click="showPreView(scope.row)">
						预览
					</span>
					<span class="pointer margin_left_10" @click="copyUrl(scope.row)">
						复制链接
					</span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import clipboard from "clipboard";

export default {
	props: ["tableData"],
	name: "",
	data() {
		return {
			value: true,
		};
	},
	methods: {
		showPreView(row) {
			let url = "https://me.news/contents/" + row.id;
			if (row.type == 2) {
				url = "https://me.news/news/" + row.id;
			}
			window.open(url, "预览");
		},
		copyUrl(row) {
			let msg = "https://me.news/contents/" + row.id;
			if (row.type == 2) {
				msg = "https://me.news/news/" + row.id;
			}
			clipboard.copy(msg);
			this.$message({ message: "复制成功", type: "success" });
		},
	},
};
</script>
<style scoped>
::v-deep .rank-first {
	color: #ffd700; /* 金色 */
	font-weight: bold;
}
::v-deep .rank-second {
	color: #c0c0c0; /* 银色 */
	font-weight: bold;
}
::v-deep .rank-third {
	color: #cd7f32; /* 铜色 */
	font-weight: bold;
}
</style>
<style>
.home_article_0 {
	display: flex;
	min-width: 30px;
	height: 30px;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	background: gray;
	color: white;
	font-size: 14px;
}

.home_article_1 {
	background: red;
}

.home_article_2 {
	background: rgb(255, 104, 70);
}
.home_article_3 {
	background: rgb(234, 192, 25);
}
</style>
